<template>
  <DefaultPage>
    <div class="home-hero">
      <img class="line line-purple-top" src="~@/assets/line-purple-top.png" alt=""/>
      <img class="line line-white-top" src="~@/assets/line-white-long-swoop.png" alt=""/>
      <img class="line line-circular-inner" src="~@/assets/line-circular-inner.png" alt=""/>
      <img class="line line-circular-outer" src="~@/assets/line-circular-outer.png" alt=""/>
      <div class="hero hero-tall">
        <div class="hero-flex-wrap">
          <div class="grid-container">
            <div class="hero__call">
              <div
                class="hero__tagline"
                data-aos="fade-right"
                data-aos-delay="200"
                data-aos-duration="1000"
              >
                The 2023 Annual Report
              </div>
              <h1
                class="hero__headline"
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-duration="1000"
              >
                We exist for your<br/>strong defense.
              </h1>
              <div
                data-aos="fade-left"
                data-aos-delay="1000"
                data-aos-duration="1000"
                data-aos-offset="-50"
              >
                <a
                  class="hero__button button large hollow"
                  @click="playVideo"
                >
                  Watch a quick video.
                </a>
              </div>
              <div
                class="hero-scroll-indicator"
                data-aos="fade-up"
                data-aos-delay="1600"
                data-aos-duration="1200"
                data-aos-offset="-100"
              >
                <div class="hero-scroll-indicator__mouse"></div>
                <div class="hero-scroll-indicator__line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeHeroVideo ref="video" />
    </div>
    <div class="orbs-bg">
      <img class="line line-blue-home" src="~@/assets/line-blue-long-swoop.png" alt=""/>
      <div
        class="orb purple"
        style="top: 400px; left: -200px;"
      ></div>
      <div
        class="orb blue"
        style="bottom: -100px; right: -50px;"
      ></div>
      <HomeQuotes />
      <HomeLetter />
      <TheSubFooter next-route="/strong-legal-defense" />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import HomeHeroVideo from '@/components/home/HomeHeroVideo';
import HomeQuotes from '@/components/home/HomeQuotes';
import HomeLetter from '@/components/home/HomeLetter';

export default {
  name: 'Home',
  components: {
    DefaultPage,
    TheSubFooter,
    HomeHeroVideo,
    HomeQuotes,
    HomeLetter
  },
  methods: {
    playVideo () {
      const $video = $('[data-video]');
      const videoTop = $video.offset().top;
      const videoHeight = $video.outerHeight();
      const windowHeight = $(window).height();
      const centeringSpace = (windowHeight - videoHeight) / 2;
      $('html, body').animate(
        { scrollTop: videoTop - centeringSpace },
        1000,
        () => {
          this.$refs.video.showPopup();
        }
      );
    }
  }
};
</script>
